const Poll = {
  option1: "",
  option2: "",
  option3: null,
  option4: null,
  title: "",
  duration: "",
};

export default Poll;